import React from "react";
import Logo from "./Logo";
import ProgramSocialLinks from "./ProgramSocialLinks";
import PropTypes from "prop-types";

export default function FooterProgramInfo({ program }) {
  const { external_links } = program;
  const linkKeys = Object.keys(external_links);
  let hasLinks = false;
  linkKeys.forEach((key) => {
    if (external_links[key]) hasLinks = true;
  });
  if (!hasLinks) return null;
  return (
    <div className="Footer-programInfo">
      <Logo program={program} />
      <ProgramSocialLinks program={program} />
    </div>
  );
}

FooterProgramInfo.propTypes = {
  program: PropTypes.object.isRequired,
};
